<template>
    <el-dialog title="批量关联元数据" width="70%" append-to-body :close-on-click-modal="false" :visible.sync="visible">
        <el-row :gutter="20" class="h100">
            <el-col :span="6" class="el-table-container">
                <div class="m_b1">元数据列表</div>
                <el-input class="m_b1" placeholder="输入关键字查询" v-model="filterText" size="small"></el-input>
                <el-tree class="h100 metadataTree" :data="treeData" :props="defaultProps" v-loading="treeLoading"
                         ref="myTree" node-key="id" check-strictly show-checkbox highlight-current default-expand-all
                         :filter-node-method="filterNode" @check="selBasicData">
                    <el-tooltip slot-scope="{ node, data }" effect="dark" :content="node.label" placement="top-start">
                        <div class="omit">
                            <img class="treeIcon" src="@/assets/img/dimensionalityIcon.png" v-if="data.basicType == 0"><img class="treeIcon" src="@/assets/img/atomIcon.png" v-else>
                            <span class="label">{{ node.label }}</span>
                        </div>
                    </el-tooltip>
                </el-tree>
            </el-col>
            <el-col :span="18">
                <el-table size="small" ref="dataList" :data="dataList" row-key="id" border v-loading="loading"
                          class="table draggable">
                    <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="basicName" label="元数据名称" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="basicType" label="类型" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{$dictUtils.getDictLabel("basic_type", scope.row.basicType ,'')}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="basicRename" label="别称" width="240">
                        <template slot-scope="{row}">
                            <el-form class="batchRelevance" :ref="'keyForm'+row.id" label-width="0px" :model="row">
                                <el-form-item prop="basicRename"
                                              :rules="[{required: true, message: '必填', trigger: 'blur'}]">
                                    <el-input class="w80" v-model.trim="row.basicRename" maxlength="10" size="mini"
                                              placeholder="请输入别称"
                                              clearable></el-input>
                                </el-form-item>
                            </el-form>

                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="80">
                        <template slot-scope="{ row, $index }">
                            <el-link icon="el-icon-rank" type="primary" class="allowDrag" :underline="false"></el-link>
                            <el-link icon="el-icon-delete" class="m_l1" type="danger" :underline="false" @click="del(row, $index)"></el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>保存</el-button>
        </div>
        <el-dialog title="保存失败" width="40%" append-to-body :close-on-click-modal="false" :visible.sync="visibleFail">
            <el-table size="small" :data="failDataList" border class="table">
                <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="basicName" label="元数据名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="reasonForSavingFailure" label="保存失败原因" show-overflow-tooltip></el-table-column>
            </el-table>
            <div slot="footer">
                <el-button size="small" @click="visibleFail = false">关闭</el-button>
            </div>
        </el-dialog>
    </el-dialog>
</template>

<script>
    import Sortable from 'sortablejs'

    export default {
        data() {
            return {
                visible: false,
                loading: false,
                filterText: '',
                basicDataId: '',
                treeData: [],
                treeLoading: false,
                defaultProps: {
                    children: 'children',
                    label: 'basicName'
                },
                dataList: [],
                // 保存失败
                visibleFail: false,
                failDataList: [],
            }
        },
        watch: {
            filterText(val) {
                this.$refs.myTree.filter(val);
            }
        },
        mounted() {
        },
        methods: {
            // 初始化数据
            init(basicDataId) {
                this.filterText = ''
                this.dataList = []
                this.basicDataId = basicDataId
                this.visible = true
                this.$nextTick(() => {
                    this.rowDrop();
                    this.searchTree()
                })
            },
            // 查询树状数据
            searchTree() {
                this.treeLoading = true
                this.$axios(this.api.metadata.selectTreeNotInBasicDataId, {basicDataId: this.basicDataId}).then(res => {
                    if (res.status) {
                        this.treeData = res.data
                    }
                    this.treeLoading = false
                })
            },
            // 选择元数据
            selBasicData(nodeObj, SelectedObj) {
                let list = JSON.parse(JSON.stringify(SelectedObj.checkedNodes))
                list.map(item => {
                    this.$set(item, 'basicRename', item.basicName)
                })
                this.dataList.map(val => {
                    list.map(item => {
                        if(val.id == item.id) {
                            this.$set(item, 'basicRename', val.basicRename)
                        }
                    })
                })
                this.dataList = list
                this.dataList.map(item => {
                    delete item.children
                })

            },
            // 过滤树
            filterNode(value, data) {
                if (!value) return true;
                return data.basicName.indexOf(value) !== -1;
            },
            // 排序
            rowDrop() {
                const tbody = document.querySelector(".draggable .el-table__body-wrapper tbody");
                new Sortable(tbody, {
                    animation: 150,
                    ghostClass: "ghostClass",
                    handle: ".allowDrag",//设置操作区域
                    onEnd(evt) {}
                })
            },
            // 删除
            del(row, index) {
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.dataList.splice(index, 1);
                    this.$refs.myTree.setChecked(row.id, false);
                })
            },
            // 表单提交
            doSubmit() {
                let flagNum = 0
                this.dataList.map(item => {
                    this.$refs['keyForm' + item.id].validate((valid) => {
                        if (valid) {
                            flagNum++
                        }
                    })
                })
                this.$nextTick(() => {
                    if (this.dataList.length == flagNum) {
                        this.loading = true
                        let p = []
                        this.dataList.map((item, index) => {
                            p.push({
                                associationBasicId: item.id,
                                basicAssemblyId: item.basicAssemblyId,
                                basicDataId: item.basicDataId,
                                basicParentId: item.basicParentId,
                                basicRename: item.basicRename,
                                basicSort: index + 1
                            })
                        })
                        this.$axios(this.api.metadata.batchAssociateMetadataBasicData, p, 'post').then(data => {
                            if (data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refreshDataList')
                            } else {
                                this.failDataList = data.data
                                this.visibleFail = true
                                // this.$message.error(data.msg)
                            }
                            this.loading = false
                        })
                    }
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .moveIcon {
        margin-right: 10px;
        cursor: pointer;
        width: 8px;
        vertical-align: sub;
    }
</style>
